import router from "@/sites/user/router";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import { MeService } from "@/common/api";

@Module({ namespaced: true })
export default class MemberAuthModule extends VuexModule {
  token = localStorage.getItem("token") || "";
  expiredAt = "";
  role = "";
  userLogging: any;
  refreshToken = "";

  get getLoggingUser() {
    return this.userLogging;
  }

  @Mutation
  setToken(token: string): void {
    this.token = token;
    localStorage.setItem("token", token);
  }

  @Mutation
  setRefreshToken(refreshToken: string): void {
    this.refreshToken = refreshToken;
    localStorage.setItem("refresh_token", refreshToken);
  }

  @Mutation
  setExpiredAt(time: string): void {
    this.expiredAt = time;
  }

  @Mutation
  setUserLogging(user): void {
    this.userLogging = user;
  }

  @Action({ rawError: true })
  updateToken(token: string): void {
    this.context.commit("setToken", token);
  }

  @Action({ rawError: true })
  updateRefreshToken(refreshToken: string): void {
    this.context.commit("setRefreshToken", refreshToken);
  }

  @Action
  updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }

  @Action
  setUser(user) {
    this.context.commit("setUserLogging", user);
  }

  @Action
  async fetchCurrentUser(): Promise<void> {
    try {
      const response = await MeService.meProfile({});
      this.context.commit("setUserLogging", response.data.member);
    } catch {
      this.context.commit("setToken", "");
      this.context.commit("setRefreshToken", "");
      this.context.commit("setExpiredAt", "");
      this.context.commit("setUserLogging", null);
      router.push({ name: "login" });
    }
  }

  @Action
  logout(redirect = true): void {
    this.context.commit("setToken", "");
    this.context.commit("setRefreshToken", "");
    this.context.commit("setExpiredAt", "");
    this.context.commit("setUserLogging", null);
    redirect && router.push({ name: "login" });
  }
}

// export default getModule(AuthModule);
